var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('h1',[_vm._v("Visitor Forms")])]),_c('v-row',[(_vm.error)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()]),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.answers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }